export interface ReferenceTextParts {
  additionalInfo?: string
  title?: string
  page?: string
  // language code selecting the page prefix (see PAGE_PREFIX)
  lang?: string
}

// page prefix = separator + abbreviation before the page number, per language
const PAGE_PREFIX: Record<string, string> = {
  de: ', S. ',
  en: ', ',
}
const DEFAULT_LANG = 'en'

// build a reference/citation string from its parts
// - order: additionalInfo, title, page
// - page is trimmed; whitespace-only page => no page prefix
// - exactly one trailing period is ensured
// - empty result => ''
export const buildReferenceText = ({
  additionalInfo = '',
  title = '',
  page = '',
  lang = DEFAULT_LANG,
}: ReferenceTextParts): string => {
  const trimmedPage = page.trim()
  const pagePrefix = PAGE_PREFIX[lang] ?? PAGE_PREFIX[DEFAULT_LANG]

  const additionalInfoPart = additionalInfo ? `${additionalInfo} ` : ''
  const pagePart = trimmedPage ? `${pagePrefix}${trimmedPage}` : ''
  const text = `${additionalInfoPart}${title}${pagePart}`.trimEnd()

  if (!text) {
    return ''
  }

  return text.endsWith('.') ? text : `${text}.`
}
